// Import action types.
import ActionTypes from './actionTypes.js';

// Selectors.
import Selectors from './selectors.js';

// Config.
import Config from './config/config.js';

/**
 * <pre>
 * Sharing module Actions.
 *
 * Summary of responsibilities:
 *
 *  - implements Redux action creators specific to component
 *
 * FYI:
 *
 * We are using {@link https://github.com/gaearon/redux-thunk|Redux Thunk} middleware on our {@link https://github.com/reactjs/redux|Redux} store.
 * For this reason you will see that inside each action creator, we return a function, rather than an action object directly.
 * </pre>
 *
 * @see {@link https://github.com/gaearon/redux-thunk|Redux Thunk Documentation}
 * @see {@link https://github.com/reactjs/redux|Redux Documentation}
 *
 * @author Tim Loram

 * @memberof module:Sharing
 * @namespace
 *
 * @type {Object}
 */
const Actions = {
  /**
   * Share something.
   *
   */
  share: function(id, network, shareData) {
    return dispatch => {
      // Get Api service.
      const apiService = NGXD.getServiceContainer().getService('api');
      // Call share Api.
      apiService.execute('action', shareData.action, shareData);

      // Dispatch action to mark item as shared.
      dispatch({
        type:      ActionTypes.SHARE,
        id:        id,
        network:   network,
        shareData: shareData,
      });
    };
  },
};

export default Actions;
